// src/Pages/MDCreateSI.js
import React,{useState} from 'react';

import * as yup from "yup";
import { useNavigate, useParams } from 'react-router-dom';
import { ErrorMessage, Formik, Form, Field } from "formik";
import Axios from "axios";
import { toast } from 'react-toastify';
import CloudProHeader from './CloudProHeader';
import "../Styles/CLoudProLoginPage.css";
const CloudProMDCreateSI = () => {
  const navigate = useNavigate();
  const { mdId } = useParams();

 const [errors, setErrors] = useState({ firstName: false });
  const handleCreateUser = (values, { resetForm }) => {
   
    Axios.post(`/create_si`, {
      mdId,
      firstname: values.firstName,
      lastname: values.lastName,
      companyname: values.companyName,
      email: values.email,
      yubikey: values.yubikeySerialNumber,
      adminEmail: localStorage.getItem('userEmail'),
      role: "Admin", // hard-coded: SI Admin only
    })
      .then((res) => {
        if (res?.data?.success) {
          toast.success(res.data.msg || "SI Admin created!");
          resetForm();
        } else {
          toast.error(res?.data?.msg || "Failed to create SI Admin.");
        }
      })
      .catch(() => toast.error("Network error. Please try again."));
  };

  const validations = yup.object().shape({
    firstName: yup.string().required("First name is mandatory"),
    lastName: yup.string().required("Last name is mandatory"),
    companyName: yup.string().required("Company name is mandatory"),
    email: yup.string().email("Invalid email").required("Email is mandatory"),
    yubikeySerialNumber: yup.string().required("YubiKey Serial Number is mandatory"),
  });

  return (

<>
<CloudProHeader isAdmin={true} />
   <div className="main-container">

         <div className="login-card">
          
           <h2 className="title">Create System Integrator Admin</h2>
           <Formik
          initialValues={{
            firstName: '',
            lastName: '',
            email: '',
            companyName: '',
            yubikeySerialNumber: '',
          }}
          onSubmit={handleCreateUser}
          validationSchema={validations}
        >
        <Form className="register-form">

  <div className="input-group">
    <label>First Name</label>
    <Field  style={{left: "0%"}}
      name="firstName"
      type="text"
      placeholder="Enter First Name"
     
    />
    <ErrorMessage
      component="span"
      name="firstName"
      className="adduser-form-error"
    />
  </div>

  <div className="input-group">
    <label>Last Name</label>
    <Field
      name="lastName"
      type="text"
      placeholder="Enter Last Name"
     
    />
    <ErrorMessage
      component="span"
      name="lastName"
      className="adduser-form-error"
    />
  </div>

  <div className="input-group">
    <label>Company Name</label>
    <Field
      name="companyName"
      type="text"
      placeholder="Enter Company Name"
      
    />
    <ErrorMessage
      component="span"
      name="companyName"
      className="adduser-form-error"
    />
  </div>

  <div className="input-group">
    <label>Email</label>
    <Field
      name="email"
      type="email"
      placeholder="Enter Email"
      
    />
    <ErrorMessage
      component="span"
      name="email"
      className="adduser-form-error"
    />
  </div>

  <div className="input-group">
    <label>YubiKey Serial Number</label>
    <Field
      name="yubikeySerialNumber"
      type="text"
      placeholder="Enter YubiKey Serial Number"
     
    />
    <ErrorMessage
      component="span"
      name="yubikeySerialNumber"
      className="adduser-form-error"
    />
  </div>

  <button className="signin-btn" type="submit">
    Create System Integrator Admin
  </button>

</Form>
        </Formik>
           </div>
           
           
    
      
    </div>
    </>
  );
};

export default CloudProMDCreateSI;
